import { render, staticRenderFns } from "./Productsku.vue?vue&type=template&id=28477fd5&scoped=true&"
import script from "./Productsku.vue?vue&type=script&lang=js&"
export * from "./Productsku.vue?vue&type=script&lang=js&"
import style0 from "./Productsku.vue?vue&type=style&index=0&id=28477fd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28477fd5",
  null
  
)

export default component.exports